// extracted by mini-css-extract-plugin
export default {"ChooseBody":"ChooseCard_ChooseBody__cBIa-","chooseTitle":"ChooseCard_chooseTitle__e4cZP","p":"ChooseCard_p__0Pnj1"};